import { useState } from 'react';

/**
 * TaskDetailActions の props。
 */
export interface TaskDetailActionsProps {
  /** 削除を出すか（作る前の新しいタスクや、消す口が無いときは出さない） */
  canDelete: boolean;
  /** 直したところがあるか。無ければ保存を押せない */
  changed: boolean;
  /** 消すときに呼ばれる */
  onDelete: () => void;
  /** 取りやめるときに呼ばれる */
  onCancel: () => void;
  /** 保存するときに呼ばれる */
  onSave: () => void;
}

/**
 * @graph-stack ado-task
 * @graph-domain Finance
 * @graph-business タスク詳細の下の操作（削除・取りやめる・保存）。削除は取り返しがつかないので、1 回目は確認に切り替え、もう一度押して消す
 * @graph-connects none
 */
export function TaskDetailActions({
  canDelete,
  changed,
  onDelete,
  onCancel,
  onSave,
}: TaskDetailActionsProps) {
  const [confirming, setConfirming] = useState(false);
  return (
    <div className="mt-5 flex items-center justify-end gap-2">
      {!canDelete ? null : confirming ? (
        <span className="mr-auto flex items-center gap-1.5 text-xs text-[var(--color-text-secondary)]">
          本当に消しますか？
          <button
            type="button"
            onClick={onDelete}
            className="rounded border border-[var(--color-overdue)] px-2.5 py-1 text-sm text-[var(--color-overdue)]"
          >
            消す
          </button>
          <button
            type="button"
            onClick={() => {
              setConfirming(false);
            }}
            className="rounded border border-[var(--color-border-subtle)] px-2.5 py-1 text-sm text-[var(--color-text-secondary)]"
          >
            戻る
          </button>
        </span>
      ) : (
        <button
          type="button"
          onClick={() => {
            setConfirming(true);
          }}
          className="mr-auto rounded border border-[var(--color-border-subtle)] px-3 py-1.5 text-sm text-[var(--color-overdue)]"
        >
          削除
        </button>
      )}
      <button
        type="button"
        onClick={onCancel}
        className="rounded border border-[var(--color-border-subtle)] bg-[var(--color-bg-surface)] px-3 py-1.5 text-sm text-[var(--color-text-secondary)]"
      >
        取りやめる
      </button>
      <button
        type="button"
        disabled={!changed}
        onClick={onSave}
        className={
          changed
            ? 'rounded bg-[var(--color-accent)] px-3 py-1.5 text-sm font-medium text-[var(--color-bg-surface)]'
            : 'rounded bg-[var(--color-bg-subtle)] px-3 py-1.5 text-sm text-[var(--color-text-muted)]'
        }
      >
        保存
      </button>
    </div>
  );
}
